<dx-load-panel [closeOnOutsideClick]="false" [visible]="true"></dx-load-panel>
